import GetStudentTypeMixin from '@/mixins/student-type';
import { VRuntimeShell } from '@grupoa/components';

export default {
  props: {
    text: {
      type    : String,
      default : ''
    }
  },
  mixins     : [GetStudentTypeMixin],
  components : {
    VRuntimeShell
  }
};
